import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import * as Icons from '@ant-design/icons-vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(Antd)

Object.keys(Icons).forEach(key => {
    app.component(key, Icons[key])
})

app.mount('#root')
